<script setup>
import { computed } from 'vue'
import { useNotification } from "@kyvg/vue3-notification"
import FormButton from '../../components/Atoms/FormButton.vue'
import FormSwitch from '../../components/Atoms/FormSwitch.vue'
import ButtonCopyToClipboard from '../../components/Moleculas/ButtonCopyToClipboard.vue'
import IconBase from '../../components/icon/IconBase.vue'
import IconLinkExternal from '../icon/IconLinkExternal.vue'
import FormInput from '../Atoms/FormInput.vue'
import EmbedCodeWidget from '@/components/Moleculas/EmbedCodeWidget.vue';
import { track, EVENTS } from '@/lib/tracking'

const { notify } = useNotification()

const props = defineProps({
	stream: {
		type: Object,
		required: true,
		validator(v) {
			return Object.prototype.hasOwnProperty.call(v, '_id')
		}
	},
	settings: {
		type: Object,
		required: true,
	},
})

const autoplayEnabled = computed(() => {
	const s = props.settings
	return Boolean(s.autoPlay?.status ?? s.embedAutoplay?.status)
})

const query = computed(() => {
	const s = props.settings
	let loop = ''
	let autoPlayNext = ''
	let autoPlay = ''
	let shuffle = ''
	s.loop?.status ? loop = '&loop=on' : loop = ''
	s.autoPlayNext?.status ? autoPlayNext = '&autoPlayNext=true' : autoPlayNext = ''
	autoplayEnabled.value ? autoPlay = '&autoplay=true' : autoPlay = ''
	s.shuffle?.status ? shuffle = '&shuffle=true' : shuffle = ''

	let queryString = loop + autoPlayNext + autoPlay + shuffle
	if (queryString.length) {
		queryString = '?' + queryString.substring(1)
	}
	return queryString
})

const getPlayerUrl = computed(() => {
	return 'https://player.castr.com/playlist/' + props.stream?._id + query.value
})

const clipboardCopy = async (text) => {
	await navigator.clipboard.writeText(text)
	notify({ group: 'info', text: 'Copied to clipboard' })
}

const trackPlaylistUrlCopied = () => {
	track(EVENTS.CONTENT_URL_COPIED, { contentType: 'playlist' })
}
// EmbedCodeWidget wraps the copy button (ButtonCopyToClipboard -> VDropdown, class
// `v-popper`). Only fire when the copy control was clicked, not the Responsive toggle.
const onPlaylistEmbedAreaClick = (e) => {
	if (e.target?.closest?.('.v-popper')) {
		track(EVENTS.EMBED_CODE_COPIED, { contentType: 'playlist', copyType: props.settings?.responsive?.status ? 'responsive' : 'fixed' })
	}
}
</script>

<template>
	<section class="bg-surface-2 !p-3 !rounded-lg">
		<div @click="onPlaylistEmbedAreaClick">
			<EmbedCodeWidget :url="getPlayerUrl" :disabled="!getPlayerUrl" v-model="settings.responsive.status" />
		</div>
		<div class="flex items-center relative gap-x-2 mb-6">
			<FormInput
				label="Direct Player Link"
				:modelValue="getPlayerUrl"
				customClasses="!pr-16"
				@click="clipboardCopy(getPlayerUrl); trackPlaylistUrlCopied()"
				readonly
			/>
			<ButtonCopyToClipboard class="absolute right-6 bottom-0.5 z-10" isIcon :text="getPlayerUrl" @click="trackPlaylistUrlCopied" />
			<FormButton class="absolute right-0 bottom-0.5 z-10" :href="getPlayerUrl" isIcon target="_blank" type="link">
				<icon-base class="shrink-0" fill="transparent">
					<IconLinkExternal />
				</icon-base>
			</FormButton>
		</div>
	</section>
</template>
